import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, EffectFade } from 'swiper/modules';
import './ImageSlider.css';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';

const ImageSlider = () => {
    const SERVER_URL = process.env.REACT_APP_API_URL;
    const token = JSON.parse(localStorage.getItem('key'));

    const [slides, setSlides] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        const getNewsFeedsThree = async () => {
            try {
                const response = await fetch(`${SERVER_URL}api/news/dashboard-news-feed`, {
                    method: 'GET',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token?.value}`,
                    },
                    signal,
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const result = await response.json();
                if (result.status === true) {
                    const dynamicSlides = result.result.map((item) => ({
                        image: `${SERVER_URL}news/${item.image}`,
                        title: item.title,
                        // subtitle: item.title.substring(0, 65),
                        remark: item.remark,
                    }));

                    setSlides(dynamicSlides); // ✅ update React state
                }
            } catch (err) {
                if (err.name !== 'AbortError') {
                    setError(err.message || 'An error occurred');
                }
            }

            return () => controller.abort();
        };

        getNewsFeedsThree();
    }, []);
    // console.log('slides', slides)
    if (error) return <div className="error">Error: {error}</div>;
    if (!slides.length) return <div className="loading">Loading slider...</div>;

    return (
        <Swiper
            modules={[Autoplay, Pagination, EffectFade]}
            effect="fade"
            style={{ width: '100%', height: '325px' }}
            autoplay={{ delay: 4000 }}
            pagination={{ clickable: true }}
            loop={true}
            className="mySwiper"
        >
            {slides.map((slide, index) => (
                <SwiperSlide key={index}>
                    <div className="slide-container">
                        <img src={slide.image} alt={slide.title} className="slide-image" />
                        <div className="slide-text">
                            <h2>{slide.title}</h2>
                            <p>{slide.remark.substring(0, 65)}</p>
                            {/* <button>{slide.buttonText}</button> */}
                        </div>
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
    );
};

export default ImageSlider;